import { VerificationType } from "../../../../constants";
import { request } from "../../utils/request/request";

export const getCodeStatus = async (uuid, verificationType = VerificationType.Sms) => {
    const sentData = new FormData();
    sentData.append("uuid", uuid);

    const response = await request.post(`/bg/${verificationType}/status`, sentData);

    return response.data;
};
